<template>
    <div v-if="hasBackBtn" class="common-back"><som-icon name="arrow-left" color="#ff571a" @click.native="goBack"></som-icon>{{title}}</div>
</template>

<script>
export default {
    name: 'back',
    data() {
        return {
            hasBackBtn: false
        };
    },
    props: ['title'],
    created() {
        this.hasBackBtn = JSON.parse(localStorage.getItem('evaluationInfo')) && JSON.parse(localStorage.getItem('evaluationInfo')).hasBackBtn === 'true';
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.common-back {
    position: relative;
    width: 100%;
    height: .5rem;
    line-height: .5rem;
    text-align: center;
    font-size: .18rem;
    font-weight: bold;
    border-bottom: solid 0.005rem #E7E7E7;
}
.common-back i {
    position: absolute;
    left: .15rem;
    top: 50%;
    transform: translate(0, -50%);
    font-size: .2rem;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/common/back.vue